import { render, staticRenderFns } from "./t-mobile.vue?vue&type=template&id=da1d2b20&"
import script from "./t-mobile.vue?vue&type=script&lang=js&"
export * from "./t-mobile.vue?vue&type=script&lang=js&"
import style0 from "./t-mobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports